// Modern API layer with TypeScript - Bulgarian Healthcare System
export interface Patient {
  id: string;
  // Bulgarian Healthcare Identity Fields
  egn: string;                    // ЕГН (Bulgarian personal number)
  rzok: string;                   // Regional health insurance code  
  zdrRajon: string;              // Health region code
  fullName: {
    given: string;               // Собствено име
    sur: string;                 // Бащино име
    family: string;              // Фамилно име
  };
  address: string;
  isHealthInsurance: boolean;     // Health insurance status
  
  // Optional contact fields
  email?: string;
  phone?: string;
  dateOfBirth: string;
  gender: 'male' | 'female';     // Пол
  medicalHistory?: string;
  
  // System fields
  createdAt: string;
  updatedAt: string;
}

export interface CreatePatientRequest {
  // Required Bulgarian fields
  egn: string;
  rzok: string;
  zdrRajon: string;
  fullName: {
    given: string;
    sur: string;
    family: string;
  };
  address: string;
  isHealthInsurance: boolean;
  dateOfBirth: string;
  gender: 'male' | 'female';
  
  // Optional fields
  email?: string;
  phone?: string;
  medicalHistory?: string;
}

export interface UpdatePatientRequest extends Partial<CreatePatientRequest> {
  id: string;
}

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8080/api';

// API functions
export const patientApi = {
  // Get all patients
  getPatients: async (): Promise<Patient[]> => {
    const response = await fetch(`${API_BASE}/patients`);
    if (!response.ok) {
      throw new Error('Failed to fetch patients');
    }
    return response.json();
  },

  // Get patient by ID
  getPatient: async (id: string): Promise<Patient> => {
    const response = await fetch(`${API_BASE}/patients/${id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch patient');
    }
    return response.json();
  },

  // Create new patient
  createPatient: async (data: CreatePatientRequest): Promise<Patient> => {
    const response = await fetch(`${API_BASE}/patients`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error('Failed to create patient');
    }
    return response.json();
  },

  // Update patient
  updatePatient: async (data: UpdatePatientRequest): Promise<Patient> => {
    const response = await fetch(`${API_BASE}/patients/${data.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error('Failed to update patient');
    }
    return response.json();
  },

  // Delete patient
  deletePatient: async (id: string): Promise<void> => {
    const response = await fetch(`${API_BASE}/patients/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete patient');
    }
  },
};